<div class="margins d-flex flex-column align-items-center montserrat justify-content-center">
  <div class="kh-text-primary kh-heading-sm pb-kh-5 pt-kh-7">
    {{ 'MERGE_ACCOUNT_CONFIRMATION.MERGE_ACCOUNT' | translate }}
  </div>

  <ng-container *ngIf="mergeInfo$ | async as mergeInfo">

    <kh-merge-account-preview *ngIf="mergeInfo.isAccepted" [targetDisplayName]="mergeInfo.toMergeDisplayName" [targetEmail]="mergeInfo.toMergeEmail" [sourceDisplayName]="mergeInfo.destinationDisplayName" [sourceEmail]="mergeInfo.destinationEmail"></kh-merge-account-preview>

    <form *ngIf="mergeInfo.isAccepted" [formGroup]="confirmMergeForm" class="form-container d-flex align-items-start mt-kh-5">
      <kh-common-checkbox [formControl]="getCheckboxControl()" [khA11yLabel]="'MERGE_ACCOUNT_CONFIRMATION.MERGE_ACCOUNT_PARTS.KH_MESSAGE_FORMAT' | translate" class="mr-kh-2"></kh-common-checkbox>
      <ng-template #email>
        <span class="kh-title-md">{{mergeInfo.destinationEmail}}</span>
      </ng-template>
      <div class="text-box-size kh-body-md kh-text-primary pb-kh-5 text-left">
        <span
          [translateWithFormat]="'MERGE_ACCOUNT_CONFIRMATION.MERGE_ACCOUNT_PARTS.KH_MESSAGE_FORMAT'"
          [templateParams]="{ email: email }">
        </span>
      </div>
    </form>
                
    <button *ngIf="mergeInfo.isAccepted" type="button" class="continue-button kh-danger-button kh-title-md" [disabled]="!confirmMergeForm.valid && destination" (click)="merge()">{{ 'MERGE_ACCOUNT_CONFIRMATION.MERGE_MY_ACCOUNT' | translate }}</button>

    <div *ngIf="!mergeInfo.isAccepted">{{ 'MERGE_ACCOUNT_CONFIRMATION.THE_MERGE_HAS_NOT_BEEN' | translate }}</div>
  </ng-container>

</div>
  


